import type { CSSProperties, ReactNode } from "react";
import styles from "./DeviceMockup.module.css";

interface DeviceMockupProps {
  device: "iphone" | "watch" | "ipad";
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
}

export function DeviceMockup({ device, children, className, style }: DeviceMockupProps) {
  return (
    <div className={`${styles.mockup} ${styles[device]} ${className ?? ""}`} style={style}>
      <div className={styles.frame}>
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
}
